module.exports = __webpack_public_path__ + "static/film1-a5a12cbf68ee4d633d04c2d7b606e5e7.mp4";